// Changelogs (Atualizações)
(function () {
  'use strict';

  // Variáveis
  const $btnToggle = $('.clog-toggle');
  const $btnToggleBadge = $btnToggle.find('.badge');
  const $btnClose = $('.clog-close');
  const $barSideWrp = $('.clog-wrp');
  const $barSideBody = $('.clog-body');
  const $logsList = $('.clog-list');
  const $logsLoader = $('.clog-loader');
  const urlChangelogs = 'https://faq.lpqv.com.br/panel/changelogs.php';
  //const urlChangelogs = 'http://192.168.15.50/lpqv-ajuda/panel/changelogs.php';
  let pagLogs = 1;
  let logsLoading = false;
  let logEnd = false;
  let barOpen = false;
  let firstLoad = false;

  // Tags changelogs
  const changelogsTags = {
    melhoria: 'Melhoria',
    novidade: 'Novidade',
    correcao: 'Correção',
    checkout: 'Checkout',
    tema: 'Tema',
    loja: 'Loja Virtual',
  };

  // Evento de click no botão pra exibir/ocultar a barra
  $btnToggle.on('click', function (ev) {
    ev.preventDefault();
    toggleBar();
  });

  // Oculta a barra ao clicar do botão de fechar
  $btnClose.on('click', function (ev) {
    ev.preventDefault();
    hideBar();
  });

  // Oculta a barra ao clicar fora
  $barSideWrp.on('click', function (ev) {
    if (ev.target == this) {
      hideBar();
    }
  });

  // Oculta a barra ao pressionar a tecla ESC
  $(document).on('keyup', function (ev) {
    if (ev.keyCode == 27) {
      hideBar();
    }
  });

  // Exibe a barra
  function showBar() {
    barOpen = true;
    $('body').css('overflow', 'hidden');
    $barSideBody.scrollTop(0);
    $barSideWrp.addClass('active');
    if (!firstLoad) {
      getChangelogs();
    }
  }

  // Oculta a barra
  function hideBar() {
    barOpen = false;
    $('body').css('overflow', 'auto');
    $barSideWrp.removeClass('active');
  }

  // Exibe ou oculta a barra
  function toggleBar() {
    if ($barSideWrp.hasClass('active')) {
      hideBar();
    } else {
      showBar();
    }
  }

  // Detecta quando o scroll chega ao final da lista
  $barSideBody.on(
    'scroll',
    debounce(function () {
      if ($barSideBody.scrollTop() + $barSideBody.innerHeight() >= $barSideBody[0].scrollHeight) {
        if (!logsLoading && !logEnd) {
          pagLogs++;
          getChangelogs();
        }
      }
    }, 50),
  );

  // Verifica os últimos registros e visualizações
  function checkViewChangelogs() {
    // Verifica se já foi feita uma checkagem na última hora
    if (localStorage.getItem('changelogs_check')) {
      let lastCLsObj = localStorage.getItem('changelogs_check');
      lastCLsObj = JSON.parse(lastCLsObj);
      const dateCheck = lastCLsObj?.time;
      const dateCheckCur = new Date().getTime();
      if (dateCheck) {
        const dateDiff = dateCheckCur - dateCheck;
        const diffHours = dateDiff / (1000 * 60 * 60);
        if (diffHours > 1) {
          getCheckChangelogs();
        } else {
          showNoViewChangelogs(lastCLsObj);
        }
      } else {
        getCheckChangelogs();
      }
    } else {
      getCheckChangelogs();
    }
    function getCheckChangelogs() {
      $.getJSON(`${urlChangelogs}?acao=check`, function (resp) {
        if (resp.status === 'success') {
          const lastCLs = resp.result;
          const totalLastCLs = resp.total;
          const lastCLsObj = {
            result: lastCLs,
            total: totalLastCLs,
            time: new Date().getTime(),
          };
          localStorage.setItem('changelogs_check', JSON.stringify(lastCLsObj));
          showNoViewChangelogs(lastCLsObj);
        } else {
          console.log(resp);
        }
      }).fail(function (resp) {
        console.log(resp);
      });
    }
    function showNoViewChangelogs(lastCLsObj) {
      if (!lastCLsObj.result) {
        return false;
      }
      const changelogsViews = localStorage.getItem('changelogs_views')
        ? localStorage.getItem('changelogs_views').split(',')
        : [];
      let totalNaoVistos = 0;
      lastCLsObj?.result.forEach((item) => {
        if (changelogsViews.indexOf('' + item) === -1) {
          totalNaoVistos++;
        }
      });
      if (totalNaoVistos > 0) {
        $btnToggleBadge.text(totalNaoVistos).show();
      } else {
        $btnToggleBadge.hide();
      }
    }
  }
  if ($logsList.length) {
    checkViewChangelogs();
  }

  // Marca um item como visto
  function viewChangelog(idItem) {
    const changelogsViews = localStorage.getItem('changelogs_views')
      ? localStorage.getItem('changelogs_views').split(',')
      : [];
    if (changelogsViews.indexOf('' + idItem) === -1) {
      changelogsViews.push(idItem);
      const changelogsViewsStr = changelogsViews.join(',');
      localStorage.setItem('changelogs_views', changelogsViewsStr);
    }
  }

  // Obtém os registros
  function getChangelogs() {
    firstLoad = true;
    logsLoading = true;
    $logsLoader.fadeIn();
    $barSideBody.scrollTop($barSideBody.prop('scrollHeight'));
    $.getJSON(`${urlChangelogs}?acao=list&p=${pagLogs}`, function (resp) {
      //console.log(resp);
      logsLoading = false;
      $logsLoader.fadeOut();
      if (resp.status === 'success') {
        populaChangelogs(resp.result);
      } else {
        console.log(resp);
      }
    }).fail(function (resp) {
      console.log(resp);
      logsLoading = false;
      $logsLoader.fadeOut();
    });
  }

  // Popula lista
  function populaChangelogs(lista) {
    if (lista.length === 0) {
      logEnd = true;
    }
    lista.forEach((item) => {
      let $tagsEl = '';
      item.tags.forEach((tag) => {
        $tagsEl += `<span class="badge badge-pill badge-tag-${tag}">${changelogsTags[tag]}</span>`;
      });
      $logsList.append(`
      <li class="clog-item" data-log="${item.id}">
        <div class="clog-item-header">
          <div class="clog-item-title">${item.titulo}</div>
          <div class="clog-item-date">${item.data_view}</div>
        </div>
        <div class="clog-item-tags">${$tagsEl}</div>
        <div class="clog-item-text">${item.texto}</div>
      </li>`);
      // Se a barra estiver aberta, marca como visto
      if (barOpen) {
        viewChangelog(item.id);
      }
    });
    let imgCLix = 0;
    $logsList.find('img').each(function () {
      imgCLix++;
      const $imgEl = $(this);
      const $linkEl = $('<a>')
        .attr('href', $imgEl.attr('src'))
        .attr('data-lightbox', '')
        .attr('rel', 'ch' + imgCLix);
      $imgEl.clone().appendTo($linkEl);
      $imgEl.replaceWith($linkEl);
    });
    initLightbox();
    checkViewChangelogs();
  }
})();
